import { Button } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react'
import { DesignContext } from 'contexts/DesignContext'
import { useContext } from 'react'
import objectPath from 'object-path'

const AddButton = ({
  uischema,
  tableColumn,
  stateParent,
  actionParent,
  addActionRef,
  pagination,
}) => {
  const { showAddButton, rowPanelAdd, setRowPanelAdd, setLoading } = stateParent
  const { handleChangePage, onRowDefaultAction } = actionParent
  const { totalCount, rowsPerPage } = pagination
  const designContext = useContext(DesignContext)
  const { jsonForm } = designContext
  const componentPropsData = objectPath.get(jsonForm, 'componentPropsData')
  const designerData = objectPath.get(componentPropsData, 'data')
  const datasourceValue = objectPath.get(designContext, '@datasource') || {}
  const saveType = objectPath.get(uischema, 'tableAction.saveType')

  const onRowPanelTableAdd = () =>
    new Promise((resolve, reject) => {
      setLoading(true)
      let newData = { '@isAdd': 1 }
      tableColumn.forEach(({ field }) => {
        objectPath.set(newData, field, undefined)
      })
      rowPanelAdd.push(newData)
      setRowPanelAdd(rowPanelAdd)
      let lastPage = Math.floor((totalCount + 1) / rowsPerPage)
      handleChangePage(lastPage, rowsPerPage)
      resolve()
    }).then(() =>
      setTimeout(() => {
        setLoading(false)
      }, 500),
    )

  return (
    <Button
      variant="outline-primary"
      disabled={rowPanelAdd.length > 0}
      onClick={() => {
        if (saveType === 'formPanel') {
          onRowPanelTableAdd()
        } else if (uischema.tableAction.editable) {
          addActionRef?.current?.click()
        } else {
          onRowDefaultAction(showAddButton?.action)
        }
      }}
    >
      <FeatherIcon size="14" icon="plus-square" className="mr-1" />
      {showAddButton?.action?.buttonText ?? 'เพิ่ม'}
    </Button>
  )
}

export default AddButton
